export const getCurrentDialog = (state) => state.dialog.currentDialog;
export const getDialogProps = (state) => state.dialog.dialogProps;
